<template>
  <div class="content">
    <div class="menology">
      <!-- 日历组件 -->
      <day-year ref="dayYear" v-model="date" />
    </div>
    <div v-if="courseList !== null" v-loading="loading" class="courseList">
      <div v-if="courseList.length === 0">
        <div class="kongImg">
          <el-image
            :src="
              $common.getResourceUrl('pcweb/pcKongStatus/img_zhengshukong.png')
            "
          />
          <p>这天没有课程哦</p>
        </div>
      </div>
      <div v-else>
        <div v-for="(item, i) in courseList" :key="i" class="courseDetails">
          <div>
            <div class="title">{{ item.chapter_title }}</div>
            <div class="course">
              <span>{{ item.course_name }} </span>
              <span v-if="item.chapter_ident">{{ item.chapter_ident }}</span>
            </div>
            <div class="time">
              <span>{{ item.start_time_show }} 开课</span>
              <span
                v-if="item.live_type == 0 && item.video_second_show"
                style="margin-left: 20px"
                >时长：{{ item.video_second_show }}</span
              >
            </div>
          </div>
          <div
            v-if="item.start_time < time"
            class="icon cursor"
            @click="go(item)"
          >
            <icon-svg icon-class="bofang" />
          </div>
          <div v-else class="icon cursor lock">
            <icon-svg icon-class="suoding" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCourseByDate } from '@/network/request'
import dayYear from '../day/day.vue'
export default {
  name: 'Kebiao',
  components: {
    dayYear,
  },
  data() {
    return {
      date: new Date(),
      time: Date.parse(new Date()) / 1000,
      loading: false,
      courseList: null, // 课表
    }
  },
  computed: {
    dateFormart() {
      const date = this.date
      const y = date.getFullYear()
      let m = date.getMonth() + 1
      if (m < 10) m = `0${m}`
      let d = date.getDate()
      if (d < 10) d = `0${d}`
      return `${y}-${m}-${d}`
    },
  },
  watch: {
    dateFormart() {
      this.loadCourses()
    },
  },
  created() {
    // console.log(Date.parse(new Date()) / 1000)
    this.loadCourses()
  },
  methods: {
    async loadCourses() {
      this.loading = true
      const date = this.dateFormart
      const res = await getCourseByDate(date, date)
      this.loading = false
      if (res.data.result === null) {
        this.courseList = []
      } else {
        this.courseList = res.data.result[date] || []
      }
    },
    go(item) {
      if (item.live_type == 0) {
        let routerJump = this.$router.resolve({
          name: 'courseCatalogue',
          params: { id: item.course_id },
        })
        window.open(
          routerJump.href + '?chapter_id=' + item.chapter_id,
          '_blank'
        )
      } else if (item.live_type == 1) {
        let routerJump = this.$router.resolve({
          name: 'courseChapterLive',
          params: { course_id: item.course_id, chapter_id: item.chapter_id },
        })
        window.open(routerJump.href, '_blank')
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.content {
  padding: 5px 31px 25px;
}

.menology {
  margin-bottom: 40px;
}
.kongImg {
  text-align: center;
  padding: 20px 0;

  .el-image {
    margin-bottom: 20px;
  }
  p {
    color: #8a8a8a;
  }
}
.courseDetails {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 30px;
  background-color: #f9f9f9;
  border-radius: 8px;
  margin-top: 20px;
  box-shadow: 1px 1px 5px #eee;
  .title {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 15px;
  }
  .course {
    font-size: 15px;
    margin-bottom: 20px;
  }
  .time {
    font-size: 14px;
    color: #999999;
  }
}

.icon {
  background-color: rgba(65, 156, 255, 0.1);
  border-radius: 6px;
  text-align: center;
  padding: 4px 13px;
  color: #419cff;
}
.lock {
  cursor: default;
  color: #999;
  background-color: #eee;
}
</style>
